export const LOGGED_IN = 'LOGGED_IN';
export const FAILED_LOG_IN = 'FAILED_LOG_IN';
export const LOGGING_IN = 'LOGGING_IN';




/** EDIT ACTIONS **/
export const EDIT_CARGO_PORT = 'EDIT_CARGO_PORT';
export const EDIT_CLIENT_RATE = 'EDIT_CLIENT_RATE';
export const EDIT_COMMODITY = 'EDIT_COMMODITY';
export const EDIT_COMMODITY_GROUP = 'EDIT_COMMODITY_GROUP';
export const EDIT_COMPANY = 'EDIT_COMPANY';
export const EDIT_CONFIGURATION = 'EDIT_CONFIGURATION';
export const EDIT_COST = 'EDIT_COST';
export const EDIT_COST_LINE = 'EDIT_COST_LINE';
export const EDIT_INVOICE = 'EDIT_INVOICE';
export const EDIT_INVOICE_LINE = 'EDIT_INVOICE_LINE';
export const EDIT_PORT = 'EDIT_PORT';
export const EDIT_ROLE = 'EDIT_ROLE';
export const EDIT_SERVICE = 'EDIT_SERVICE';
export const EDIT_UNDERWRITER_RATE = 'EDIT_UNDERWRITER_RATE';
export const EDIT_USER = 'EDIT_USER';

/** EDITING ACTIONS **/
export const EDITING = 'EDITING';
export const EDITING_CARGO_PORT = 'EDITING_CARGO_PORT';
export const EDITING_CLIENT_RATE = 'EDITING_CLIENT_RATE';
export const EDITING_COMMODITY = 'EDITING_COMMODITY';
export const EDITING_COMMODITY_GROUP = 'EDITING_COMMODITY_GROUP';
export const EDITING_CONFIGURATION = 'EDITING_CONFIGURATION';
export const EDITING_COST = 'EDITING_COST';
export const EDITING_COST_LINE = 'EDITING_COST_LINE';
export const EDITING_INVOICE = 'EDITING_INVOICE';
export const EDITING_INVOICE_LINE = 'EDITING_INVOICE_LINE';
export const EDITING_PORT = 'EDITING_PORT';
export const EDITING_ROLE = 'EDITING_ROLE';
export const EDITING_SERVICE = 'EDITING_SERVICE';
export const EDITING_UNDERWRITER_RATE = 'EDITING_UNDERWRITER_RATE';
export const EDITING_USER = 'EDITING_USER';


/** DONE_EDITING ACTIONS **/
export const DONE_EDITING_CARGO_PORT = 'DONE_EDITING_CARGO_PORT';
export const DONE_EDITING_CLIENT_RATE = 'DONE_EDITING_CLIENT_RATE';
export const DONE_EDITING_COMMODITY = 'DONE_EDITING_COMMODITY';
export const DONE_EDITING_COMMODITY_GROUP = 'DONE_EDITING_COMMODITY_GROUP';
export const DONE_EDITING_CONFIGURATION = 'DONE_EDITING_CONFIGURATION';
export const DONE_EDITING_COST = 'DONE_EDITING_COST';
export const DONE_EDITING_COST_LINE = 'DONE_EDITING_COST_LINE';
export const DONE_EDITING_INVOICE = 'DONE_EDITING_INVOICE';
export const DONE_EDITING_INVOICE_LINE = 'DONE_EDITING_INVOICE_LINE';
export const DONE_EDITING_PORT = 'DONE_EDITING_PORT';
export const DONE_EDITING_ROLE = 'DONE_EDITING_ROLE';
export const DONE_EDITING_SERVICE = 'DONE_EDITING_SERVICE';
export const DONE_EDITING_UNDERWRITER_RATE = 'DONE_EDITING_UNDERWRITER_RATE';
export const DONE_EDITING_USER = 'DONE_EDITING_USER';


/** CLIENT CONTACT ACTIONS **/
export const LOADING_CLIENT_CONTACT = 'LOADING_CLIENT_CONTACT';
export const SAVING_CLIENT_CONTACT = 'SAVING_CLIENT_CONTACT';
export const SAVED_CLIENT_CONTACT = 'SAVED_CLIENT_CONTACT';
export const RECEIVED_CLIENT_CONTACTS = 'RECEIVED_CLIENT_CONTACTS';
export const ERROR_SAVING_CLIENT_CONTACTS = 'ERROR_SAVING_CLIENT_CONTACTS';
export const DONE_DELETING_CLIENT_CONTACT = 'DONE_DELETING_CLIENT_CONTACT';
export const DELETING_CLIENT_CONTACT = 'DELETING_CLIENT_CONTACT';

/** CLIENT RATE ACTIONS **/
export const LOADING_CLIENT_RATE = 'LOADING_CLIENT_RATE';
export const SAVING_CLIENT_RATE = 'SAVING_CLIENT_RATE';
export const SAVED_CLIENT_RATE = 'SAVED_CLIENT_RATE';
export const RECEIVED_CLIENT_RATES = 'RECEIVED_CLIENT_RATES';
export const ERROR_SAVING_CLIENT_RATES = 'ERROR_SAVING_CLIENT_RATES';
export const DONE_DELETING_CLIENT_RATE = 'DONE_DELETING_CLIENT_RATE';
export const DELETING_CLIENT_RATE = 'DELETING_CLIENT_RATE';

/** UNDERWRITER RATE ACTIONS **/
export const LOADING_UNDERWRITER_RATE = 'LOADING_UNDERWRITER_RATE';
export const SAVING_UNDERWRITER_RATE = 'SAVING_UNDERWRITER_RATE';
export const SAVED_UNDERWRITER_RATE = 'SAVED_UNDERWRITER_RATE';
export const RECEIVED_UNDERWRITER_RATES = 'RECEIVED_UNDERWRITER_RATES';
export const ERROR_SAVING_UNDERWRITER_RATES = 'ERROR_SAVING_UNDERWRITER_RATES';
export const DONE_DELETING_UNDERWRITER_RATE = 'DONE_DELETING_UNDERWRITER_RATE';
export const DELETING_UNDERWRITER_RATE = 'DELETING_UNDERWRITER_RATE';

/** CLIENT ACTIONS **/
export const LOADING_CLIENT = 'LOADING_CLIENT';
export const SAVING_CLIENT = 'SAVING_CLIENT';
export const SAVED_CLIENT = 'SAVED_CLIENT';
export const RECEIVED_CLIENTS = 'RECEIVED_CLIENTS';
export const ERROR_SAVING_CLIENTS = 'ERROR_SAVING_CLIENTS';
export const DONE_DELETING_CLIENT = 'DONE_DELETING_CLIENT';
export const DELETING_CLIENT = 'DELETING_CLIENT';

/** CURRENCY ACTIONS **/
export const LOADING_CURRENCY = 'LOADING_CURRENCY';
export const SAVING_CURRENCY = 'SAVING_CURRENCY';
export const SAVED_CURRENCY = 'SAVED_CURRENCY';
export const RECEIVED_CURRENCY = 'RECEIVED_CURRENCY';
export const ERROR_SAVING_CURRENCY = 'ERROR_SAVING_CURRENCY';

/** FOG ACTIONS **/
export const LOADING_FOG = 'LOADING_FOG';
export const SAVING_FOG = 'SAVING_FOG';
export const SAVED_FOG = 'SAVED_FOG';
export const RECEIVED_FOGS = 'RECEIVED_FOGS';
export const RECEIVED_FOG = 'RECEIVED_FOG';
export const ERROR_SAVING_FOG = 'ERROR_SAVING_FOG';
export const DUPLICATING_FOG = 'DUPLICATING_FOG';
export const DONE_DUPLICATING_FOG = 'DONE_DUPLICATING_FOG';
export const UPDATEDATAFORM_FOG = 'UPDATEDATAFORM_FOG';
export const CLEARDATAFORM_FOG = 'CLEARDATAFORM_FOG';

/** VESSEL ACTIONS **/
export const LOADING_VESSEL = 'LOADING_VESSEL';
export const SAVING_VESSEL = 'SAVING_VESSEL';
export const SAVED_VESSEL = 'SAVED_VESSEL';
export const RECEIVED_VESSELS = 'RECEIVED_VESSELS';
export const ERROR_SAVING_VESSELS = 'ERROR_SAVING_VESSELS';
export const DONE_DELETING_VESSEL = 'DONE_DELETING_VESSEL';
export const DELETING_VESSEL = 'DELETING_VESSEL';

/** UNDERWRITER ACTIONS **/
export const LOADING_UNDERWRITER = 'LOADING_UNDERWRITER';
export const SAVING_UNDERWRITER = 'SAVING_UNDERWRITER';
export const SAVED_UNDERWRITER = 'SAVED_UNDERWRITER';
export const RECEIVED_UNDERWRITERS = 'RECEIVED_UNDERWRITERS';
export const ERROR_SAVING_UNDERWRITERS = 'ERROR_SAVING_UNDERWRITERS';
export const DONE_DELETING_UNDERWRITER = 'DONE_DELETING_UNDERWRITER';
export const DELETING_UNDERWRITER = 'DELETING_UNDERWRITER';

/** COMPANY ACTIONS **/
export const LOADING_COMPANY = 'LOADING_COMPANY';
export const SAVING_COMPANY = 'SAVING_COMPANY';
export const SAVED_COMPANY = 'SAVED_COMPANY';
export const RECEIVED_COMPANIES = 'RECEIVED_COMPANIES';
export const ERROR_SAVING_COMPANIES = 'ERROR_SAVING_COMPANIES';

/** COUNTRY ACTIONS **/
export const LOADING_COUNTRY = 'LOADING_COUNTRY';
export const SAVING_COUNTRY = 'SAVING_COUNTRY';
export const SAVED_COUNTRY = 'SAVED_COUNTRY';
export const RECEIVED_COUNTRIES = 'RECEIVED_COUNTRIES';
export const ERROR_SAVING_COUNTRIES = 'ERROR_SAVING_COUNTRIES';

/** COMPANY CONTACT ACTIONS **/
export const LOADING_COMPANY_CONTACT = 'LOADING_COMPANY_CONTACT';
export const SAVING_COMPANY_CONTACT = 'SAVING_COMPANY_CONTACT';
export const SAVED_COMPANY_CONTACT = 'SAVED_COMPANY_CONTACT';
export const RECEIVED_COMPANY_CONTACTS = 'RECEIVED_COMPANY_CONTACTS';
export const ERROR_SAVING_COMPANY_CONTACTS = 'ERROR_SAVING_COMPANY_CONTACTS';

/** CARGO ACTIONS **/
export const LOADING_CARGO = 'LOADING_CARGO';
export const SAVING_CARGO = 'SAVING_CARGO';
export const SAVED_CARGO = 'SAVED_CARGO';
export const RECEIVED_CARGOES = 'RECEIVED_CARGOES';
export const RECEIVED_CARGO = 'RECEIVED_CARGO';
export const ERROR_SAVING_CARGO = 'ERROR_SAVING_CARGO';
export const DONE_DELETING_CARGO = 'DONE_DELETING_CARGO';
export const DELETING_CARGO = 'DELETING_CARGO';
export const UPDATEFORMDATA_CARGO = 'UPDATEFORMDATA_CARGO';
export const CLEARFORMDATA_CARGO = 'CLEARFORMDATA_CARGO';


/** COST ACTIONS **/
export const LOADING_COST = 'LOADING_COST';
export const SAVING_COST = 'SAVING_COST';
export const SAVED_COST = 'SAVED_COST';
export const RECEIVED_COSTS = 'RECEIVED_COSTS';
export const RECEIVED_COST = 'RECEIVED_COST';
export const ERROR_SAVING_COST = 'ERROR_SAVING_COST';
export const UPDATED_FILE = 'UPDATED_FILE';
export const UPDATEFORMDATA_COST = 'UPDATEFORMDATA_COST';
export const CLEARFORMDATA_COST = 'CLEARFORMDATA_COST';
export const REMOVED_COST = 'REMOVED_COST';

/** INVOICE ACTIONS **/
export const LOADING_INVOICE = 'LOADING_INVOICE';
export const SAVING_INVOICE = 'SAVING_INVOICE';
export const SAVED_INVOICE = 'SAVED_INVOICE';
export const RECEIVED_INVOICES = 'RECEIVED_INVOICES';
export const RECEIVED_INVOICE = 'RECEIVED_INVOICE';
export const ERROR_SAVING_INVOICE = 'ERROR_SAVING_INVOICE';
export const REMOVED_INVOICE = 'REMOVED_INVOICE';

/** COMMODITY ACTIONS **/
export const LOADING_COMMODITY = 'LOADING_COMMODITY';
export const SAVING_COMMODITY = 'SAVING_COMMODITY';
export const SAVED_COMMODITY = 'SAVED_COMMODITY';
export const RECEIVED_COMMODITIES = 'RECEIVED_COMMODITIES';
export const RECEIVED_COMMODITY = 'RECEIVED_COMMODITY';
export const ERROR_SAVING_COMMODITY = 'ERROR_SAVING_COMMODITY';
export const DONE_DELETING_COMMODITY = 'DONE_DELETING_COMMODITY';
export const DELETING_COMMODITY = 'DELETING_COMMODITY';

/** COMMODITY GROUP ACTIONS **/
export const LOADING_COMMODITY_GROUP = 'LOADING_COMMODITY_GROUP';
export const SAVING_COMMODITY_GROUP = 'SAVING_COMMODITY_GROUP';
export const SAVED_COMMODITY_GROUP = 'SAVED_COMMODITY_GROUP';
export const RECEIVED_COMMODITY_GROUPS = 'RECEIVED_COMMODITY_GROUPS';
export const RECEIVED_COMMODITY_GROUP = 'RECEIVED_COMMODITY_GROUP';
export const ERROR_SAVING_COMMODITY_GROUP = 'ERROR_SAVING_COMMODITY_GROUP';

/** PORT ACTIONS **/
export const LOADING_PORT = 'LOADING_PORT';
export const SAVING_PORT = 'SAVING_PORT';
export const SAVED_PORT = 'SAVED_PORT';
export const RECEIVED_PORTS = 'RECEIVED_PORTS';
export const ERROR_SAVING_PORTS = 'ERROR_SAVING_PORTS';
export const DONE_DELETING_PORT = 'DONE_DELETING_PORT';
export const DELETING_PORT = 'DELETING_PORT';

/** FILES ACTIONS **/
export const LOADING_FILES = 'LOADING_FILES';
export const SAVING_FILES = 'SAVING_FILES';
export const SAVED_FILES = 'SAVED_FILES';
export const RECEIVED_FILES = 'RECEIVED_FILES';
export const ERROR_SAVING_FILES = 'ERROR_SAVING_FILES';
export const DONE_DELETING_FILES = 'DONE_DELETING_FILES';
export const DELETING_FILES = 'DELETING_FILES';
export const UPDATEFORMDATA_FILES = 'UPDATEFORMDATA_FILES';
export const CLEARFORMDATA_FILES = 'CLEARFORMDATA_FILES';


/** CARGO_PORT ACTIONS **/
export const LOADING_CARGO_PORT = 'LOADING_CARGO_PORT';
export const SAVING_CARGO_PORT = 'SAVING_CARGO_PORT';
export const SAVED_CARGO_PORT = 'SAVED_CARGO_PORT';
export const RECEIVED_CARGO_PORTS = 'RECEIVED_CARGO_PORTS';
export const RECEIVED_CARGO_PORT = 'RECEIVED_CARGO_PORT';
export const ERROR_SAVING_CARGO_PORT = 'ERROR_SAVING_CARGO_PORT';

/** SELECTED FIELD ACTIONS **/
export const SELECTED_UNDERWRITER = 'SELECTED_UNDERWRITER';
export const UNSELECTED_UNDERWRITER = 'UNSELECTED_UNDERWRITER';
export const SELECTED_VESSEL = 'SELECTED_VESSEL';
export const UNSELECTED_VESSEL = 'UNSELECTED_VESSEL';
export const SELECTED_CLIENT = 'SELECTED_CLIENT';
export const UNSELECTED_CLIENT = 'UNSELECTED_CLIENT';
export const SELECTED_COMPANY = 'SELECTED_COMPANY';
export const UNSELECTED_COMPANY = 'UNSELECTED_COMPANY';

export const TOGGLE_DISPLAY_ALL_FILTER = 'TOGGLE_DISPLAY_ALL_FILTER';

export const IS_DIRTY = 'IS_DIRTY';
export const IS_NOT_DIRTY = 'IS_NOT_DIRTY';

/** NEWLY_CREATED_ELEMENTS ACTIONS */
export const NEWLYCREATED_NEW_CARGO = 'NEWLYCREATED_NEW_CARGO';
export const NEWLYCREATED_NEW_CARGO_PORT = 'NEWLYCREATED_NEW_CARGO_PORT';
export const NEWLYCREATED_NEW_CLIENT = 'NEWLYCREATED_NEW_CLIENT';
export const NEWLYCREATED_NEW_CLIENT_CONTACT = 'NEWLYCREATED_NEW_CLIENT_CONTACT';
export const NEWLYCREATED_NEW_CLIENT_RATE = 'NEWLYCREATED_NEW_CLIENT_RATE';
export const NEWLYCREATED_NEW_COMMODITY = 'NEWLYCREATED_NEW_COMMODITY';
export const NEWLYCREATED_NEW_COMMODITY_GROUP = 'NEWLYCREATED_NEW_COMMODITY_GROUP';
export const NEWLYCREATED_NEW_COMPANY = 'NEWLYCREATED_NEW_COMPANY';
export const NEWLYCREATED_NEW_COMPANY_CONTACT = 'NEWLYCREATED_NEW_COMPANY_CONTACT';
export const NEWLYCREATED_NEW_COST = 'NEWLYCREATED_NEW_COST';
export const NEWLYCREATED_NEW_COUNTRY = 'NEWLYCREATED_NEW_COUNTRY';
export const NEWLYCREATED_NEW_CURRENCY = 'NEWLYCREATED_NEW_CURRENCY';
export const NEWLYCREATED_NEW_FOG = 'NEWLYCREATED_NEW_FOG';
export const NEWLYCREATED_NEW_INVOICE = 'NEWLYCREATED_NEW_INVOICE';
export const NEWLYCREATED_NEW_PORT = 'NEWLYCREATED_NEW_PORT';
export const NEWLYCREATED_NEW_UNDERWRITER = 'NEWLYCREATED_NEW_UNDERWRITER';
export const NEWLYCREATED_NEW_UNDERWRITER_RATE = 'NEWLYCREATED_NEW_UNDERWRITER_RATE';
export const NEWLYCREATED_NEW_VESSEL = 'NEWLYCREATED_NEW_VESSEL';

export const NEWLYCREATED_CLOSE_CARGO = 'NEWLYCREATED_CLOSE_CARGO';
export const NEWLYCREATED_CLOSE_CARGO_PORT = 'NEWLYCREATED_CLOSE_CARGO_PORT';
export const NEWLYCREATED_CLOSE_CLIENT = 'NEWLYCREATED_CLOSE_CLIENT';
export const NEWLYCREATED_CLOSE_CLIENT_CONTACT = 'NEWLYCREATED_CLOSE_CLIENT_CONTACT';
export const NEWLYCREATED_CLOSE_CLIENT_RATE = 'NEWLYCREATED_CLOSE_CLIENT_RATE';
export const NEWLYCREATED_CLOSE_COMMODITY = 'NEWLYCREATED_CLOSE_COMMODITY';
export const NEWLYCREATED_CLOSE_COMMODITY_GROUP = 'NEWLYCREATED_CLOSE_COMMODITY_GROUP';
export const NEWLYCREATED_CLOSE_COMPANY = 'NEWLYCREATED_CLOSE_COMPANY';
export const NEWLYCREATED_CLOSE_COMPANY_CONTACT = 'NEWLYCREATED_CLOSE_COMPANY_CONTACT';
export const NEWLYCREATED_CLOSE_COST = 'NEWLYCREATED_CLOSE_COST';
export const NEWLYCREATED_CLOSE_COUNTRY = 'NEWLYCREATED_CLOSE_COUNTRY';
export const NEWLYCREATED_CLOSE_CURRENCY = 'NEWLYCREATED_CLOSE_CURRENCY';
export const NEWLYCREATED_CLOSE_FOG = 'NEWLYCREATED_CLOSE_FOG';
export const NEWLYCREATED_CLOSE_INVOICE = 'NEWLYCREATED_CLOSE_INVOICE';
export const NEWLYCREATED_CLOSE_PORT = 'NEWLYCREATED_CLOSE_PORT';
export const NEWLYCREATED_CLOSE_UNDERWRITER = 'NEWLYCREATED_CLOSE_UNDERWRITER';
export const NEWLYCREATED_CLOSE_UNDERWRITER_RATE = 'NEWLYCREATED_CLOSE_UNDERWRITER_RATE';
export const NEWLYCREATED_CLOSE_VESSEL = 'NEWLYCREATED_CLOSE_VESSEL';


export const GENERATING_DOCUMENT = 'GENERATING_DOCUMENT';
export const DONE_GENERATING_DOCUMENT = 'DONE_GENERATING_DOCUMENT';
export const ERROR_GENERATING_DOCUMENT = 'ERROR_GENERATING_DOCUMENT';

export const CANCEL_DOCUMENT = 'CANCEL_DOCUMENT';
export const DONE_CANCEL_DOCUMENT = 'DONE_CANCEL_DOCUMENT';
export const ERROR_CANCEL_DOCUMENT = 'ERROR_CANCEL_DOCUMENT';



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js